module.exports = __webpack_public_path__ + "img/section4_2.eb6d0f8f.png";